/* Stylesheet */

.survival_plot_options {
  position: relative;
}

.backdrop {
  position: fixed;
  opacity: 0;
  height: 100%;
  top: 0;
  cursor: default;
}
